import { useNavigate } from 'react-router-dom'

import { AffiliateListComponent } from '../../components/AffiliateList'
import { ButtonComponent } from '../../components/Button'
import { LayoutPage } from '../../components/LayoutPage'
import { PageTitleComponent } from '../../components/PageTitleComponent'
import { PaginationComponent } from '../../components/Pagination'
import { SpinnerComponent } from '../../components/Spinner'

import { useControlSearchAffiliates } from '../../hooks/useControlSearchAffiliates'
import { useSimpleState } from '../../hooks/useSimpleState'
import { useView } from '../../hooks/useView'

import './index.css'

const ManageAffiliatesPage = () => {
    const navigate = useNavigate()

    const { _state } = useSimpleState({
        fetching: false
    })

    const {_view: _viewMain} = useView({
        initialView: 'main',
        views: {
            loading: renderLoading,
            main: renderMain
        }
    })

    const {_control, _results, _page} = useControlSearchAffiliates({
        beforeFetch: () => _state.set('fetching', true),
        afterFetch: () => _state.set('fetching', false)
    })

    const handleGoToEdit = (item) => {
        navigate(`/edit-affiliate/${item.id}`)
    }

    const handleDelete = (item) => {
        if (window.confirm(`Delete ${item.displayName || item.name}?`))
            _control.fetchDelete(item)
    }

    const handlePageChange = (page) => {
        _control.goToPage(page)
    }

    function renderLoading() {
        return (
            <div>
                <SpinnerComponent />
            </div>
        )
    }

    function renderMain() {
        let results = _results.get()
        let affiliates = results?.body?.data || []
        let lastPage = results?.body?.meta?.last_page || results?.body?.meta?.lastPage || 1

        return (
            <div>
                <LayoutPage config={{ id: 'ManageDeals' }}>
                    <div className="manageDeals-header">
                        <PageTitleComponent value="Affiliates" />
                        <ButtonComponent events={{ handleClick: () => navigate('/create-affiliate') }}>
                            + New Affiliate
                        </ButtonComponent>
                    </div>

                    <div className="manageDeals-panel">
                        <div className={`manageAffiliates-listContainer ${_state.get('fetching') ? 'disabled' : ''}`}>
                            {affiliates.length ? (
                                <AffiliateListComponent value={affiliates} events={{
                                    handleEdit: handleGoToEdit,
                                    handleDelete: handleDelete
                                }} />
                            ) : (
                                <div className="manageDeals-empty">No affiliates yet.</div>
                            )}
                        </div>

                        {lastPage > 1 ? (
                            <div className="manageDeals-footerBar">
                                <PaginationComponent
                                    value={_page.get()}
                                    config={{ lastPage, size: 'small' }}
                                    events={{ handleChange: handlePageChange }}
                                />
                            </div>
                        ) : null}
                    </div>
                </LayoutPage>
            </div>
        )
    }

    return _viewMain.get()
}

export { ManageAffiliatesPage }
